/**
 * Browser storage that belongs to one signed-in person. Cleared on sign-out
 * (useAuth's clearUserScopedState) and on account deletion, so the next
 * person on the same browser does not inherit it.
 */

/** Onboarding answers in progress; the full key is `${prefix}:${userId}`. */
export const ONBOARDING_PROGRESS_KEY_PREFIX = 'unipostudio_onboarding_progress';

/** The storage key for one person's onboarding progress. */
export function onboardingProgressKey(userId: string | null | undefined): string {
  return userId ? `${ONBOARDING_PROGRESS_KEY_PREFIX}:${userId}` : ONBOARDING_PROGRESS_KEY_PREFIX;
}

const USER_SCOPED_PREFIXES: readonly string[] = [ONBOARDING_PROGRESS_KEY_PREFIX];

/** Remove every user-scoped key (the legacy unscoped onboarding key too). */
export function clearUserScopedStorage(): void {
  try {
    const doomed: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && USER_SCOPED_PREFIXES.some((p) => key === p || key.startsWith(`${p}:`))) doomed.push(key);
    }
    for (const key of doomed) localStorage.removeItem(key);
  } catch {
    // Storage unavailable: nothing was stored either.
  }
}
